import React, { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";
import { loginReturnForPage } from "./utils/townReturn";

// Vuoto = stessa origine (es. tutto su http://127.0.0.1:8080)
const BACKEND_URL = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");
const API = BACKEND_URL ? `${BACKEND_URL}/api` : "/api";
const authClient = axios.create({ baseURL: API, withCredentials: true, timeout: 30000 });

const AuthContext = createContext(null);

/** Porta a /registrati in modalità login con prompt Google (GIS). */
export function getGoogleLoginUrl(returnPath = "/") {
  // Da una scheda borgo/città si rientra in "modalità Editor" (?editor=1)
  const [p, qs] = String(returnPath || "/").split("?");
  const ret = encodeURIComponent(loginReturnForPage(p, qs ? `?${qs}` : ""));
  return `/registrati?google=1&return=${ret}`;
}

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkAuth = async () => {
    try {
      // /auth/session ritorna 200 con {user: null} per guest → evita 401 spurri in console
      const r = await authClient.get("/auth/session", { timeout: 5000 });
      setUser(r.data?.user || null);
    } catch {
      setUser(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    // CRITICAL: If returning from OAuth callback, skip the /me check.
    // AuthCallback will exchange the session_id and establish the session first.
    if (window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return undefined;
    }

    let mounted = true;
    const bootstrapCap = window.setTimeout(() => {
      if (mounted) setLoading(false);
    }, 5000);

    checkAuth().finally(() => {
      window.clearTimeout(bootstrapCap);
    });

    return () => {
      mounted = false;
      window.clearTimeout(bootstrapCap);
    };
  }, []);

  const logout = async () => {
    try { await authClient.post("/auth/logout"); } catch { /* noop */ }
    try {
      localStorage.removeItem("6amico_admin_token");
      localStorage.removeItem("6amico_admin");
    } catch { /* noop */ }
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, logout, refresh: checkAuth, setUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext) || { user: null, loading: false, logout: () => {}, refresh: () => {}, setUser: () => {} };
}

export { authClient };
